




























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { GitRepositoryDetailHeaderTitle } from '@/@types/LibraryComponent';
import { DefaultBranchName, FindBranchesDetail } from '@/@types/theoryGit/branches';

@Component({
  components: {},
})
export default class Branchs extends Vue {
  @Prop({ required: true, default: () => [] })
  private branches!: FindBranchesDetail[];
  private headers = [
    { text: GitRepositoryDetailHeaderTitle.branchHeader.names, value: 'name' },
    { text: GitRepositoryDetailHeaderTitle.branchHeader.updates, value: 'lastUpdatedAt' },
    { text: GitRepositoryDetailHeaderTitle.branchHeader.diff, value: 'differ' },
    { text: GitRepositoryDetailHeaderTitle.branchHeader.pullRequest, value: 'pullRequestId' },
    { text: GitRepositoryDetailHeaderTitle.branchHeader.delete, value: 'delete' },
  ];

  private getDisplayText(status: string) {
    if (status) {
      return status;
    } else {
      return '追加';
    }
  }

  private checkDefaultBranchName(branchName: string) {
    return branchName === DefaultBranchName.main;
  }

  @Emit('deleteBranch')
  private deleteBranch(branchName: string) {
    return branchName;
  }
}
